import { FaFacebookF } from "react-icons/fa";
import Logo from "../assets/icons/imaging-accreditation/cdc_copy_new.png";
import footerBg from "../assets/images/header/Copper_1.jpg";
import { Link } from "react-router-dom";

export default function FooterTwo() {
  return (
    <footer
      className="text-black relative overflow-hidden bg-cover bg-no-repeat w-full bg-center"
      style={{
        backgroundImage: `url(${footerBg})`,
        backgroundPosition: "center",
        backgroundSize: "object-fit",
      }}
    >
      {/* Optional overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-20 z-0" />

      <div className="flex lg:flex-row flex-col-reverse w-full ">
        <div className="flex md:flex-row flex-col w-full lg:w-2/3 md:ps-10 ps-7 py-10 md:py-5 lg:py-0">
          <div className="2xl:ps-20 xl:ps-12 flex flex-col  justify-start md:w-1/2  z-10 w-full">
            <div className="flex justify-start pt-6 items-center flex-1">
              <Link to="/"  aria-label="Citrus Diagnostic Center">
                <img src={Logo} alt="Citrus Diagnostic Center" className="w-[250px] h-auto" />
              </Link>
            </div>
            <p className="uppercase text-sm tracking-wide mb-1 text-black opacity-70 font-robout">
              Get in touch
            </p>
            <p className="text-2xl  font-black text-black mb-2 font-robout">
              <a
                href="tel:+3527959200"
                className="text-black hover:text-[#ffffff] transition-colors  no-underline"
              >
                (352) 450-8062
              </a>
            </p>
            <Link
              to="https://maps.app.goo.gl/MQ5H5FsCB4nBt8dy7"
              target="_blank"
              aria-label="Address"
              className="text-black font-robout text-2xl hover:text-[#ffffff] font-semibold"
            >
              922 North Citrus Avenue <br />
              Crystal River, Florida 34428,<br /> United States
            </Link>
            <div className="flex gap-9  justify-start flex-row items-center mt-1 font-robout font-black ">
              <span className="text-center">See what we're up to</span>{" "}
              <Link
                to="https://www.facebook.com/pages/Citrus-Diagnostic-Center/125806944133191"
                target="_blank"
                rel="noreferrer"
                aria-label="Visit Citrus Diagnostic Center on Facebook"
              >
                <FaFacebookF className="text-[20px] hover:text-[#ffffff]" />
              </Link>
            </div>

            <Link
              to="https://www.novatales.com/"
              target="_blank"
              className="opacity-70 font-robout pb-8 pt-1 w-60 font-black hover:text-[#ffffff]"
              aria-label="Visit Novatales Media"
            >
              Powered by NovaTales
            </Link>
          </div>

          <div className="flex text-left md:w-1/2 w-full xl:ps-10 ps-0  xl:justify-start md:justify-center justify-start  items-center ">
            <div className="flex justify-center text-xl flex-col xl:gap-4 gap-2 opacity-100 z-10 font-robout font-black">
              <Link
                className="underline underline-offset-1 hover:text-white"
                to="/privacy-statement"
                aria-label="Privacy Policy"
              >
                Privacy Policy
              </Link>{" "}
              <Link
                className="underline underline-offset-1 hover:text-white"
                to="/terms-of-use"
                aria-label="Terms of Use"
              >
                Terms of Use
              </Link>{" "}
              <Link
                className="underline underline-offset-1 hover:text-white"
                to="/hippa"
                 aria-label="HIPAA"
              >
                HIPAA
              </Link>{" "}
              <Link
                className="underline underline-offset-1 hover:text-white"
                to="/disclaimer"
                 aria-label="Disclaimer"
              >
                Disclaimer{" "}
              </Link>
              <Link
                className="underline underline-offset-1 hover:text-white"
                to="/accessibility-statement"
                 aria-label="Accessibility Statement"
              >
                Accessibility Statement{" "}
              </Link>{" "}
              <Link
                className="underline underline-offset-1 hover:text-white"
                to="/anti-discrimation"
                 aria-label="Anti Discrimation"
              >
                Anti Discrimation{" "}
              </Link>{" "}
              <span className="">Copy Rights &copy; 2025</span>
            </div>
          </div>
        </div>
        <div className="lg:w-1/3 w-full z-10">
          <iframe
            title="Citrus Diagnostic Center Florida"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6985.813095337112!2d-82.591563!3d28.901124999999997!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e841badd2a4091%3A0xeb4dead7dc4f5402!2sCitrus%20Diagnostic%20Center!5e0!3m2!1sen!2sin!4v1760678219616!5m2!1sen!2sin"
            className="w-full md:h-[450px] h-[300px]"
            height=""
            width="100%"
            allowFullScreen="true`"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </footer>
  );
}
